import React, { Component } from 'react';
import limparUltimosHistoricosTrecho from '../../actions/trecho/limparUltimosHistoricosTrecho';
import { connect } from 'react-redux';
import $ from 'jquery';
import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import { formatarReal } from '../../util/numberUtil';

export const Cabecalho = () => (
    <div className="lista-eventos titulo">
        <div className="row cabecalho-desktop" style={{ fontWeight: 'bold' }}>
            <div className="col-12 col-sm-12 col-md">Data e Hora</div>
            <div className="col-12 col-sm-12 col-md">Situação</div>
            <div className="col-12 col-sm-12 col-md">Usuário</div>            
            <div className="col-12 col-sm-12 col-md">Cidade </div>
            <div className="col-12 col-sm-12 col-md">Embarque</div>
            <div className="col-12 col-sm-12 col-md">Duração</div>
            <div className="col-12 col-sm-12 col-md">Quilometragem</div>
            <div className="col-12 col-sm-12 col-md">Taxa de Embarque</div>            
            <div className="col-12 col-sm-12 col-md">Pedágio</div>
        </div>
    </div>
);

export class ModalHistoricoTrecho extends Component {

    fecharModal() {
        $('#modalHistoricoTrecho')
            .modal('hide');
        $('#modalHistoricoTrecho')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHistoricosTrecho();
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => <div className="lista-eventos" key={`${historico.id}-${historico.dataEvento}`}>
                <div className="row conteudo-desktop">
                    <div className="col-12 col-sm-12 col-md">
                        <Moment
                            format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</p>
                        </div>
                    </div>                    
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.trechoDto.cidadeDestino ? historico.trechoDto.cidadeDestino.nomeComUf : ''}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.trechoDto.pontoEmbarque}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.trechoDto.duracao}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.trechoDto.quilometragem}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.trechoDto.taxaEmbarque ? formatarReal(historico.trechoDto.taxaEmbarque) : ''}</p>
                        </div>
                    </div> 
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.trechoDto.pedagio ? formatarReal(historico.trechoDto.pedagio) : ''}</p>
                        </div>
                    </div>
                </div>
            </div>)
        }
        return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoTrecho' role='dialog'
                aria-labelledby='modalHistoricoTrecho' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Históricos Trecho </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons" onClick={() => this.fecharModal()}>
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <Cabecalho />
                            {this.exibirHistoricos()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export const mapStateToProps = (state) => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        historicos: state.ultimosHistoricosTrecho
    }
};

export default connect(mapStateToProps, {
    limparUltimosHistoricosTrecho
})(ModalHistoricoTrecho)